import React from "react";

import {IconName} from "../../_services/types";

const Icon = ({icon, className = ""}: {icon: IconName; className?: string}) => (
  <span className={`cIcon-${icon} ${className}`} aria-hidden />
);

export default React.memo(Icon);
